import React, { Component } from 'react'
import { connect } from 'react-redux'

// Elements
import Icon from '../../../shared/elements/icon'
import Inline from '../../../shared/elements/inline'
import Divider from '../../../shared/elements/divider'

// Styles
import './column.scss'

class Column extends Component {
  constructor (props) {
    super(props)

    this.renderTitle = this.renderTitle.bind(this)
  }

  render () {
    return (
      <div className='column'>
        <div className='column_content scrollbar'>
          <div className='column_content_inner'>
            {!this.props.noTitle && this.renderTitle()}
            {this.props.children}
          </div>
        </div>
      </div>
    )
  }

  renderTitle () {
    return (
      <div>
        <Inline block>
          {this.props.icon !== undefined && <Icon icon={this.props.icon} />}
          {this.props.title !== undefined && <h3>{this.props.title}</h3>}
          {this.props.renderRight !== null ? this.props.renderRight : null}
        </Inline>
        <Divider />
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {

})(Column)



// WEBPACK FOOTER //
// ./src/app/pages/EvaluationHistory/Column/index.js